import React from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type MoveEntityControlProps = {
  direction: 'left' | 'right'
  onClick: () => void
  disabled?: boolean
}

const MoveEntityControl = ({ direction, onClick, disabled }: MoveEntityControlProps) => {
  const label = direction === 'left' ? 'Move earlier in list' : 'Move later in list'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (disabled) return
    onClick()
  }

  return (
    <div className={cn('control', `move-entity-${direction}`)} data-graph-type="control" title={label}>
      <a className={cn('icon', { disabled })} onClick={handleClick}>
        {direction === 'left' ? <FaChevronLeft aria-hidden /> : <FaChevronRight aria-hidden />}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default MoveEntityControl
